import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { Modal, ModalBody, ModalFoot, ModalHead, Text, } from '@dixa/lib-shared-habla';
import { useMemo } from 'react';
import { createAppModal } from 'utils/modal';
import { setLocalStorageDesktopAppNoticeCache } from '../../../../utils/localStorageDesktopAppNoticeCache/localStorageDesktopAppNoticeCache';
import styles from './desktopAppNoticeModal.module.scss';
const desktopAppDownloadUrls = {
    windows: 'https://www.dixa.com/download/windows',
    mac: 'https://www.dixa.com/download/mac',
    fallback: 'https://www.dixa.com/download/',
};
export const DesktopAppNoticeModal = createAppModal({ type: 'app:desktopAppNotice' }, ({ isOpen, modal, hide }) => {
    const daysToPostpone = modal.arg.daysToPostpone;
    const handleCancel = () => {
        if (daysToPostpone !== undefined) {
            setLocalStorageDesktopAppNoticeCache({
                daysToPostpone,
            });
        }
        hide === null || hide === void 0 ? void 0 : hide();
    };
    const handleConfirm = () => {
        if (isPlatformWindows) {
            window.open(desktopAppDownloadUrls.windows, '_blank');
        }
        else if (isPlatformMac) {
            window.open(desktopAppDownloadUrls.mac, '_blank');
        }
        else {
            window.open(desktopAppDownloadUrls.fallback, '_blank');
        }
        hide === null || hide === void 0 ? void 0 : hide();
    };
    const isPlatformWindows = useMemo(() => {
        return (navigator.platform
            .toUpperCase()
            .indexOf('WIN') !== -1);
    }, []);
    const isPlatformMac = useMemo(() => {
        return (navigator.platform
            .toUpperCase()
            .indexOf('MAC') !== -1);
    }, []);
    return (_jsxs(Modal, Object.assign({ isOpen: isOpen, onClose: handleCancel, className: styles.modal }, { children: [_jsx(ModalHead, { title: "Dixa Desktop App update required", onClose: handleCancel }), _jsxs(ModalBody, { children: [_jsxs(Text.Paragraph, { children: ["You are running an unsupported version of Dixa that will", ' ', _jsx("b", { children: "stop functioning" }), " the 8th of May 2023."] }), _jsx("br", {}), _jsx(Text.Paragraph, { children: "Update as soon as possible to work uninterrupted" }), isPlatformWindows && (_jsxs(_Fragment, { children: [_jsx("br", {}), _jsxs(Text.Paragraph, { children: ["If you are using the non auto updating Dixa Desktop App (MSI standalone), see", ' ', _jsx(Text.ExternalLink, Object.assign({ href: "https://support.dixa.help/en/articles/151-deploy-dixa-via-windows-installer-msi", target: "_blank", rel: "noreferrer" }, { children: "Dixa Help Center" })), ' ', "for more information or contact your system administrator."] })] }))] }), _jsx(ModalFoot, { confirmOnClick: handleConfirm, cancelOnClick: handleCancel, confirmName: isPlatformMac
                    ? 'Download for Mac'
                    : isPlatformWindows
                        ? 'Download for Windows'
                        : 'Visit download page', cancelName: daysToPostpone > 0
                    ? `Remind me in ${daysToPostpone} day${daysToPostpone > 1 ? 's' : ''}`
                    : null })] })));
});
